// extracted by mini-css-extract-plugin
module.exports = {"summaryTable":"styles_summaryTable__2Pvvp"};